import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, currentUser } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const navigation = [
    { name: "Dashboard", href: "/", icon: LayoutDashboard },
    { name: "CA Firms", href: "/clients", icon: Users },
  ];

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div className="sidebar">
        {/* Logo Section */}
        <div className="sidebar-header">
          <div className="sidebar-logo-container">
            <img src="/ca.png" alt="CA India Logo" className="sidebar-logo-circle" />
          </div>
          <h3 className="sidebar-title">CA Vault</h3>
          <p className="sidebar-subtitle">Management Panel</p>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`sidebar-nav-link ${isActive ? "active" : ""}`}
              >
                <item.icon className="sidebar-nav-icon" size={20} />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* Logout Button */}
        <div className="sidebar-logout">
          <button
            onClick={handleLogout}
            className="sidebar-logout-btn"
          >
            <LogOut className="sidebar-nav-icon" size={20} />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="main-content flex-grow-1">
        <header className="bg-white border-bottom">
          <div className="container-fluid py-3">
            <h2 className="h4 mb-0 fw-semibold">
              Document Management System - Super Admin
            </h2>
          </div>
        </header>

        <main className="container-fluid py-4">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
